import { Navigate, NavLink, Outlet, useLocation } from 'react-router-dom';

import { Typography } from 'components/common/Typography/Typography';
import { RequireAuth } from 'components/functional/RequireAuth/RequireAuth';
import { Header } from 'components/general/Header/Header';

export function AppLayout() {
  const location = useLocation();

  const tabs = [
    { title: 'Dashboard', link: '/app/dashboard' },
    { title: 'Providers', link: '/app/providers' },
    { title: 'Patients', link: '/app/patients' },
    { title: 'Orders', link: '/app/orders' },
  ];

  if (location?.pathname === '/app/patients') {
    return <Navigate to="/app/patients/active-patients" />;
  }
  if (location?.pathname === '/app/providers') {
    return <Navigate to="/app/providers/active-providers" />;
  }

  if (location?.pathname === '/app') {
    return <Navigate to="/app/dashboard" />;
  }

  return (
    <RequireAuth>
      <div className="min-h-screen bg-background-dark">
        <div className="container bg-background-dark">
          <div className="py-4">
            <Header />
            <div className="mb-3 ml-1 mt-3 flex w-full border-b-2 border-background-light text-background-contrastText">
              {tabs.map((tab) => (
                <NavLink
                  key={tab.title}
                  to={tab.link}
                  className={({ isActive }) =>
                    `mr-5 ml-4 inline-block px-4 py-2 text-lg font-bold  ${
                      isActive ? 'text-primary-main ' : 'text-zinc-400 '
                    }`
                  }>
                  <div>
                    <Typography style={{ color: 'inherit' }} variant="h3">
                      {tab.title}
                    </Typography>
                  </div>
                </NavLink>
              ))}
            </div>
            <Outlet />
          </div>
        </div>
      </div>
    </RequireAuth>
  );
}
